import { Button } from 'components/atoms';
import { Card, FormGrid, FormInput } from 'components/molecules';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useCustomParamId } from 'hooks/useParamId';
import { usePermissionGuard } from 'hooks/usePermissionGuard';
import middleware from 'middleware';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PiGlobeSimple } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetMusicProductDigitalDeliveries,
  useGetMusicProductDigitalDeliveryConsistent,
} from 'services/music-product-digital/delivery';
import { IMusicProductDigitalForm } from 'services/music-product-digital/types/form';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const MusicProductDigitalDelivery = () => {
  usePermissionGuard('DigitalDeliveryPermissionsLIST**');

  const id = useCustomParamId('id', '/music-product-digital');

  const digitalDeliveryCosistent =
    useGetMusicProductDigitalDeliveryConsistent(id);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const {
    values,
    setFieldValue,
  }: IFormikContextType<IMusicProductDigitalForm> =
    useFormikContext<IMusicProductDigitalForm>();

  const deliveries = useGetMusicProductDigitalDeliveries(
    id,
    values.deliveryFilter?.onlyDefaultProviders
  );

  useEffect(() => {
    deliveries.refetch();
  }, [values.deliveryFilter?.onlyDefaultProviders]);

  return (
    <TopbarPage
      topbar={
        <TopBar
          size='compact'
          customBackItem={<div className='none' />}
          hideHeader
          topbarContent={
            <div className='flex w-full items-center justify-between'>
              {values.deliveryFilter?.onlyDefaultProviders ? (
                <Button
                  variant={BUTTON_VARIANT.submit}
                  onClick={() => navigate('all')}>
                  <Button.Text
                    text={
                      digitalDeliveryCosistent.data === undefined
                        ? t('button.publish-all')
                        : t('button.change-all')
                    }
                  />
                  <Button.Icon icon={<PiGlobeSimple />} />
                </Button>
              ) : (
                <div></div>
              )}
              <FormInput.Select
                label={t('input.label.filter')}
                name='deliveryFilter.onlyDefaultProviders'
                options={[
                  {
                    label: t('input.option.onlyDefaultProviders'),
                    value: true,
                  },
                  { label: t('input.option.allProviders'), value: false },
                ]}
                displayMode={false}
              />
            </div>
          }
        />
      }>
      <FormGrid minWidth={400}>
        {deliveries.data?.map((service, key) => (
          <Card.Delivery
            key={key}
            service={service}
            onClick={() => {
              setFieldValue(
                'delivery',
                middleware.digitalDelivery.serviceQueryToForm(service)
              );
              navigate(`${service.salesChannelId}/${service.providerId}`, {
                preventScrollReset: true,
              });
            }}
          />
        ))}
      </FormGrid>
    </TopbarPage>
  );
};

export default MusicProductDigitalDelivery;
